import React, { useRef } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { CommonTabsProps } from '../types/common.types';

const BRAND_COLOR = '#2F7E8E';

const CommonTabs: React.FC<CommonTabsProps> = ({ value, onChange, items }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  // The Tabs' arrow buttons only appear/work once MUI detects overflow, and many
  // users expect to just scroll the mouse wheel over a tab strip instead of
  // hunting for the arrows — redirect vertical wheel movement to horizontal scroll.
  const handleWheel = (event: React.WheelEvent<HTMLDivElement>): void => {
    const scroller = containerRef.current?.querySelector<HTMLDivElement>('.MuiTabs-scroller');
    if (!scroller || scroller.scrollWidth <= scroller.clientWidth) {
      return;
    }
    scroller.scrollLeft += event.deltaY;
  };

  return (
    <Box
      ref={containerRef}
      onWheel={handleWheel}
      sx={{
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #e2eef1',
        flexShrink: 1,
        minWidth: 0,
      }}
    >
      <Tabs
        value={value}
        onChange={(_, nextValue: string) => onChange(nextValue)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        TabIndicatorProps={{
          sx: {
            height: 3,
            borderRadius: '3px 3px 0 0',
            backgroundColor: BRAND_COLOR,
          },
        }}
        sx={{
          minHeight: 40,
          '& .MuiTabs-flexContainer': {
            columnGap: 0.5,
          },
          '& .MuiTab-root': {
            minHeight: 40,
            minWidth: 'auto',
            px: 1.75,
            py: 0.75,
            fontSize: '0.78rem',
            fontWeight: 600,
            letterSpacing: 0,
            textTransform: 'none',
            color: '#5b7a80',
            transition: 'color 0.15s ease',
            '&:hover': {
              color: BRAND_COLOR,
            },
            '&.Mui-selected': {
              color: BRAND_COLOR,
              fontWeight: 700,
            },
          },
        }}
      >
        {items.map((tab) => (
          <Tab key={tab.value} value={tab.value} label={tab.label} disableRipple />
        ))}
      </Tabs>
    </Box>
  );
};

export default CommonTabs;
